export const viewListDropDowns = [
    { dropdownName: "Event Type", fieldId: "entryType" },
    { dropdownName: "Event Topic", fieldId: "entryTopic" },
    { dropdownName: "EventZoomAccounts", fieldId: "zoomAccountHolderName" },
]
